import ArrowForwardIosRounded from '@material-ui/icons/ArrowForwardIosRounded';
import { ReactNode, useMemo, useState } from 'react';
import { AuthUserInfo } from '../../misc/lib/user';
import { useIsMobile } from '../../misc/mobile';
import './TabLayout.scss';

function TabLayout<
  T extends (readonly [] | readonly any[]) & (
    number extends T[ "length" ] ? readonly [] : unknown
  )>(props: {
    tabs: T;
    panels: { [ K in keyof T ]: ReactNode };
    user: AuthUserInfo;
  }) {
  if (props.tabs.length < 1) throw new Error('Invalid number of panels');

  const isMobile = useIsMobile();
  const [ opened, setOpened ] = useState(false);
  const [ activePageIndex, setActivePageIndex ] = useState(0);
  const tabNameElements = useMemo(() => {
    return props.tabs.map((tabName, i) => (
      <p key={ i } className={ i === activePageIndex ? 'active' : undefined }
        onClick={ () => { setActivePageIndex(i); setOpened(false); } }>
        { tabName }
      </p>
    ));
  }, [ activePageIndex, props ]);

  return props.tabs.length < 1 ? (
    <h2>Invalid number of panels</h2>
  ) : (
    <div className="tab-layout">
      { isMobile ? (
        <div className="tabs-container-mobile">
          <div className={ `current-tab-mobile${ opened ? ' opened' : '' } acrylic-translucent` }>
            <p><b>{ props.tabs[ activePageIndex ] }</b></p>
            <span onClick={ () => {
              setOpened(!opened);
            } }><ArrowForwardIosRounded color="inherit" /></span>
          </div>
          <div className={ `tabs${ opened ? ' opened acrylic-translucent' : '' }` }>
            { tabNameElements }
          </div>
        </div>
      ) : (
        <div className="tabs acrylic-translucent">
          { tabNameElements }
        </div>
      ) }
      <div className="active-panel">
        { props.panels[ activePageIndex ] }
      </div>
    </div>
  );
};

export default TabLayout;
